import {convertPrice} from '@/utils/filters'
import {persistentStore} from '@/composables/store-accessor'
import {prepareBookResult} from '@/utils/PrepareBookAdapter'
import {calcTotalPrice} from '@/utils/price-utils'
import type {Ref} from 'vue'

export function useProductStore(searchResponse: Ref) {
    const searchPage = ref(1)

    function SET_SEARCH_PAGE(page: any) {
        searchPage.value = page
    }

    function SET_SEARCH_RESPONSE(_searchResponse: any) {
        searchResponse.value = _searchResponse
    }

    const orderTotalPrice = computed(
        () =>
            (
                {price, currentPrice, supplierPrice}: any,
                prebooked: any,
                selectedAddOns: any[] = [],
                prepareBookResponse: any
            ) => {
                if (prebooked && prepareBookResponse) {
                    const result = prepareBookResult(prepareBookResponse)
                    const clientPrice = calcTotalPrice(result.map(({price}: any) => price)),
                        supplierPrice = calcTotalPrice(result.map(({supplierPrice}: any) => supplierPrice))
                    return {
                        amount: clientPrice.amount,
                        commission: clientPrice.commission?.amount || 0,
                        currency: clientPrice.currency,
                        originalAmount: clientPrice.amount,
                        originalCurrency: clientPrice.currency,
                        loyaltyPoints: prepareBookResponse?.paymentByLoyaltyPoint?.paidByLoyalty || 0,
                        supplierPriceAmount: supplierPrice.amount,
                        supplierPriceOriginalCurrencyAmount: supplierPrice.amount,
                        supplierCommission: supplierPrice.commission?.amount || 0,
                        loyaltyAmount: prepareBookResponse?.paymentByLoyaltyPoint?.paidByLoyalty || 0,
                    }
                }

                const offerPrice = prebooked && currentPrice ? currentPrice : price,
                    originalCurrency = offerPrice.originalCurrency || offerPrice.currency,
                    originalAmount = offerPrice.originalAmount || offerPrice.amount
                const supplierPriceObj = supplierPrice?.originalAmount
                    ? {amount: supplierPrice?.originalAmount, currency: supplierPrice?.originalCurrency}
                    : {amount: supplierPrice?.amount, currency: supplierPrice?.currency}
                const convertedSupplierPrice = convertPrice(
                    supplierPriceObj,
                    persistentStore.getCurrency(originalCurrency)
                )
                const convertedSupplierPriceOriginal = convertPrice(supplierPriceObj, originalCurrency)

                const totalOfferPrice: any = {
                    amount: convertPrice(offerPrice).amount,
                    currency: persistentStore.getCurrency(originalCurrency),
                    originalAmount,
                    originalCurrency,
                    loyaltyAmount: offerPrice.loyaltyAmount,
                    supplierPriceAmount: convertedSupplierPrice?.amount,
                    supplierPriceOriginalCurrencyAmount: convertedSupplierPriceOriginal?.amount,
                }
                if (offerPrice?.commission) totalOfferPrice.commission = convertPrice(offerPrice.commission).amount
                if (supplierPrice?.commission?.originalAmount || supplierPrice?.commission?.amount) {
                    totalOfferPrice.supplierCommission =
                        supplierPrice?.commission?.originalAmount || supplierPrice?.commission?.amount
                }
                for (const {
                    product: [{offers}],
                } of selectedAddOns.filter(({free}) => !free)) {
                    for (const {price, loyaltyPoints, supplierPrice} of offers) {
                        totalOfferPrice.amount += convertPrice(price).amount
                        if (originalCurrency === price.currency) {
                            totalOfferPrice.originalAmount += price.amount
                        } else {
                            totalOfferPrice.originalAmount += convertPrice(price, originalCurrency).amount
                        }
                        if (price.commission) {
                            totalOfferPrice.commission += convertPrice(price.commission).amount
                        }
                        if (supplierPrice?.commission?.originalAmount || supplierPrice?.commission?.amount) {
                            totalOfferPrice.supplierCommission =
                                supplierPrice?.commission?.originalAmount || supplierPrice?.commission?.amount
                        }
                        totalOfferPrice.loyaltyPoints += loyaltyPoints || 0
                        totalOfferPrice.loyaltyAmount += price.loyaltyAmount || 0
                    }
                }
                return totalOfferPrice
            }
    )

    return {searchPage, SET_SEARCH_PAGE, SET_SEARCH_RESPONSE, orderTotalPrice}
}
